import { NgModule, ModuleWithProviders } from '@angular/core';
import { SecurityPermissionsService } from './services/security-permissions.service';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  providers: [ SecurityPermissionsService ],
  imports: [ HttpClientModule ]
})
export class DuSecurityValidatorModule {
  static forRoot (): ModuleWithProviders {
    return {
      ngModule: DuSecurityValidatorModule,
      providers: [
        SecurityPermissionsService,
      ]
    };
  }
}
